export const EXTERNAL_URLS = {
  dupontUrl: "https://www.dupont.com/",
  waveProURL: "https://wavepro.dupont.com",
  privacyUrl: "https://www.dupont.com/privacy.html",
  a11yUrl: "https://www.dupont.com/accessibility.html",
  contactDupontUrl: "https://www.dupont.com/water/contact-us.html",
  engagementURL: "https://www.dupont.com/dupont/submitForm?orgId=WS",
  resourceCenterUrl: "https://www.dupont.com/resource-center.html?BU=water",
  termsConditions: "https://www.dupont.com/legal-notices-and-terms-of-use.html",
  ufConfigurationHelp:
    "https://watersolutions.showpad.com/share/mQ7eHe3T8KitIs6g9dzAp",
  carouselLink:
    "https://www.dupont.com/water/resources/wave-pro-design-software.html",
  ultrafiltrationURL:
    "https://www.dupont.com/water/technologies/ultrafiltration-uf.html",
  ionExchangeURL:
    "https://www.dupont.com/water/technologies/ion-exchange-ix.html",
  youtubeURL: "https://www.youtube.com/channel/UCWVgaECFNjMWDczgCTI4pFw",
  instagramURl:
    "https://www.instagram.com/accounts/login/?next=https%3A%2f%2fwww.instagram.com%2fdupontwatersolutions%2f&is_from_rle",
  linkedinURL: "https://www.linkedin.com/showcase/dupont-water-solutions",
  digitalTermsConditions:
    "https://water-protection.dupont.com/digital-program-terms-and-conditions-of-use.html",
  myProfile: "https://www.dupont.com/signin/my-profile.html",
};

export const FOOTER_URL = {
  en: {
    dupontUrl: "https://www.dupont.com/",
    privacyUrl: "https://www.dupont.com/privacy.html",
    termsConditions:
      "https://www.dupont.com/legal-notices-and-terms-of-use.html",
    a11yUrl: "https://www.dupont.com/accessibility.html",
  },
  zh: {
    dupontUrl: "https://www.dupont.cn/",
    privacyUrl: "https://www.dupont.cn/privacy.html",
    termsConditions:
      "https://www.dupont.cn/legal-notices-and-terms-of-use.html",
    a11yUrl: "https://www.dupont.cn/accessibility.html",
  },
};

export const XTPUrlStrings = {
  en: {
    moreInfoLink:
      "https://www.dupont.com/content/dam/water/amer/us/en/water/public/documents/en/UF-IntegraTec-XTP-100-IG-Flyer-45-D04977-en.pdf",
  },
  zh: {
    moreInfoLink:
      "https://www.dupont.com/content/dam/water/amer/us/en/water/public/documents/en/UF-IntegraTec-XTP-100-IG-Flyer-45-D04977-en.pdf",
  },
};
